<div mat-dialog-header>
  <h1> Are you sure you would like to initiate a case? </h1>
</div>
<mat-dialog-content class="dialog-container col-12">
  <div class="row mt-2">
    <div class="col-12">
      <mat-form-field class="w-50">
        <mat-label>Assigned To</mat-label>
        <input
          type="text"
          matInput
          name="repCodeControl"
          [placeholder]="'Assigned To'"
          [matAutocomplete]="auto"
          [value]="repCodeValue"
          [formControl]="repCodeControl"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="setRepCode($event)"
        >
          @for (opt of caseUsers; track $index) {
            <mat-option value="{{ opt.value }}">
              {{ opt.value }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>

  @if (data.alerts && data.alerts.length > 0) {
    <div class="row mt-2">
      <div class="alert-checks-container col-12">
        <div class="w-100 mb-2">
          @if (data.amlMode) {
            <strong>
              The following alert will be addressed in in the newly created case
            </strong>
          } @else {
            <strong>
              Please select which alert{{
                data.alerts && data.alerts.length > 1 ? 's' : ''
              }}
              needs to be addressed in the newly created case
            </strong>
          }
        </div>
        @for (alert of data.alerts; track alert) {
          <mat-checkbox
            [checked]="caseAlerts.includes(alert.name)"
            [disabled]="data.amlMode"
            (change)="toggleAlert($event, alert)"
          >
            {{ alert.name }} | {{ alert.score }}
          </mat-checkbox>
        }
      </div>
    </div>
  }
</mat-dialog-content>
<div mat-dialog-actions class="row buttons">
  <button
    type="button"
    mat-raised-button
    color="accent"
    [disabled]="!repCodeValue"
    (click)="confirmCaseCreation()"
  >
    Confirm
  </button>
  <button type="button" mat-raised-button (click)="dialogRef.close()">
    Cancel
  </button>
</div>
